<template>
  <div style="height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);margin: 0 20px;overflow-y: auto">
      <div style="height: 50px">
        <el-button type="primary" plain icon="el-icon-plus" @click="addServiceContent()">新建</el-button>&nbsp;
        <el-input prefix-icon="el-icon-search" placeholder="输入服务商搜索" v-model="searchKeyword" clearable style="width: 300px"></el-input>
      </div>
      <div style="max-height: calc(100% - 50px);overflow-y: auto">
        <el-table v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="tableData" border style="width: 100%" highlight-current-row ref="singleTable">
          <el-table-column
            type="index"
            label="序号"
            width="70"
          align="center">
          </el-table-column>
          <el-table-column
            prop="name"
            label="服务商"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            label="所属组织"
            min-width="100"
            align="center">
            <template slot-scope="scope">
              <span>{{getOnOrg(scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="地址"
            min-width="160"
            align="center">
          </el-table-column>
          <el-table-column
            prop="telephone"
            label="电话号码"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            prop="createtime"
            label="录入时间"
            min-width="140"
            align="center">
          </el-table-column>
          <el-table-column align="center" label="服务内容" width="80"  class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" plain @click="openContent(scope.row)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="80"  class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editService(scope.row)"></i>
              <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delService(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height:40px;text-align: center">
        <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
        </el-pagination>
      </div>
    </div>
    <!--服务内容-->
    <el-dialog :visible.sync="seeShow" v-if="seeShow" width="650px" :show-close="true"
               :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div> <span>【{{addEditObj.row.name}}】- 服务内容</span> </div>
        <div class="line-title"></div>
        <see-content :addEdit="addEditObj" v-model="seeShow"></see-content>
      </div>
    </el-dialog>
    <!--created update-->
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="700px" :show-close="true"
      :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div> <span>{{openTitle}}</span> </div>
        <div class="line-title"></div>
      </div>
      <add-edit-service :addEdit="addEditObj" v-model="addEditShow" @updateTableSupp="querySupplier"></add-edit-service>
    </el-dialog>
  </div>
</template>

<script>
import {deletesupplierorg, querysupplierorgnotype, querysuppliertype} from '../../api/serviceMark'
import {queryorg} from '../../api/organizer'
import addEditService from './childComponents/addEditService'
import seeContent from './childComponents/seeContent'
export default {
  name: 'serviceProvider',
  components: {addEditService, seeContent},
  data () {
    return {
      orgData: [],
      searchKeyword: '',
      tableData: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      openTitle: '',
      addEditShow: false,
      addEditObj: {
        isAdd: true,
        row: {},
        orgData: [],
        types: []
      },
      seeShow: false
    }
  },
  created () {
    this.golobleObject.updateTableSupp = this.querySupplier
    this.querySupplierTypeData()
    this.getOrgData()
  },
  mounted () {
  },
  computed: {
    // tbdata () {
    //   return this.searchFilterWord()
    // }
  },
  methods: {
    // 服务类型
    querySupplierTypeData () {
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        orgid: []
      }
      querysuppliertype(params, data).then(res => {
        this.addEditObj.types = res.data.types
      }).catch(() => {
        this.loading = false
      })
    },
    // 组织
    getOrgData () {
      this.loading = true
      queryorg().then(res => {
        this.orgData = res.data.org
        this.addEditObj.orgData = this.orgData
        this.querySupplier()
      }).catch(() => {
        this.loading = false
      })
    },
    querySupplier () {
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      querysupplierorgnotype(params).then(res => {
        this.loading = false
        this.tableData = res.data.org
        this.totalCells = res.data.cnt
      }).catch(() => {
        this.loading = false
      })
    },
    getOnOrg (row) {
      for (let i = 0; i < this.orgData.length; i++) {
        if (row.orgid === this.orgData[i].id) {
          return this.orgData[i].name
        }
      }
    },
    addServiceContent () {
      this.openTitle = '新建服务商'
      this.addEditObj.isAdd = true
      this.addEditObj.row = {}
      this.addEditShow = true
    },
    editService (row) {
      this.openTitle = '更新服务商'
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    delService (row) {
      let name = row.name
      this.$confirm('此操作将永久删除该服务商【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          soids: [row.id]
        }
        deletesupplierorg(data).then(res => {
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.querySupplier()
          this.$notify({
            title: '成功',
            message: '删除服务商成功',
            type: 'success',
            duration: 2000
          })
        }).catch(() => {})
      }).catch(() => {})
    },
    openContent (row) {
      this.addEditObj.row = row
      this.seeShow = true
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.querySupplier()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.querySupplier()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/serviceprovider/index.vue